import { useUserContext } from 'contexts/UserContext/UserContextProvider';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useAuthorization = (requiredPermissions) => {
  const { rbacCandidateControl } = useFlags();
  const { currentUser, isLoading } = useUserContext();

  if (rbacCandidateControl) {
    return true;
  }

  if (isLoading) return undefined;
  return !!requiredPermissions.find(
    (permission) => currentUser?.role === permission,
  );
};
